import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppShell, } from "@inteacc/app-shell";
import { useApplicationContext, } from "./context";
const CompanyControl = () => {
    const { currentCompany, session, switchCompany, } = useApplicationContext();
    if (session.availableCompanies.length < 2 || !switchCompany) {
        return (_jsx("span", { className: "iaf-experience-company", children: currentCompany?.companyDisplayName ?? session.tenant.tenantDisplayName }));
    }
    return (_jsxs("label", { className: "iaf-experience-company", children: [_jsx("span", { children: "Company" }), _jsx("select", { "aria-label": "Active company", onChange: (event) => {
                    void switchCompany(event.target.value);
                }, value: currentCompany?.companyId ?? "", children: session.availableCompanies.map((company) => (_jsx("option", { value: company.companyId, children: company.companyDisplayName }, company.companyId))) })] }));
};
export const ApplicationExperienceShell = ({ brandHref, frame, collapsibleNavigation, children, headerActions, navigation, navigationLabel, onNavigate, }) => {
    const { application, currentCompany, session } = useApplicationContext();
    const groups = navigation.map((group) => ({
        id: group.id,
        label: group.label,
        items: group.items.map((item) => ({
            id: item.id,
            label: item.label,
            href: item.href,
            ...(item.iconRole ? { iconRole: item.iconRole } : {}),
            current: item.current,
        })),
    }));
    return (_jsx(AppShell, { applicationName: application.name, ...(frame ? { frame } : {}), ...(collapsibleNavigation !== undefined ? { collapsibleNavigation } : {}), ...(brandHref ? { brandHref } : {}), contextControl: _jsx(CompanyControl, {}), contextLabel: currentCompany?.companyDisplayName ?? session.tenant.tenantDisplayName, ...(headerActions ? { headerActions } : {}), navigationGroups: groups, ...(navigationLabel ? { navigationLabel } : {}), ...(onNavigate ? { onNavigate } : {}), userLabel: session.displayName, children: children }));
};
//# sourceMappingURL=shell.js.map